import React from "react";
import { Container, Row, Col, Button, Card } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { toAbsoluteUrl } from "../../_helpers";
import SVG from "react-inlinesvg";
export default function CompleteProfilePage() {
  const history = useHistory();
 
  return (
    <Container
      fluid
      className="d-flex justify-content-center align-items-center bg-overlay"
      style={{minHeight:"88vh"}}
    >
       
      <Row className="custom-width-kyc justify-content-center" >
        <Col>
          <Card className="shadow-lg border-0 rounded-4 p-3 bg-white">
            <Card.Body className="text-center">
              {/* Icon */}
              <div className="row">
                <div className="col-12 text-center mb-12">
                    <div className="font-size-h4 font-weight-bolder">Complete Your Profile to Keep Access</div>
                    <div className="font-size-sm">For a secure, compliant experience, please complete your profile.</div>
                </div>
                <div className="col-12 mb-5">
                  <div  className="font-size-h5 font-weight-bold"> Why it Matters: </div>
                </div>
                <div className="col-12 d-flex align-items-center mb-5">
                    <SVG height={20} width={20} src={toAbsoluteUrl(`/media/General/SeePrices.svg`)} />
                    <p className="m-0 ml-3">See Prices & Certificate Details</p>
                </div>
                <div className="col-12 d-flex align-items-center mb-5">
                    <SVG height={20} width={20} src={toAbsoluteUrl(`/media/General/ExclusiveIndustry.svg`)} />
                    <p className="m-0 ml-3">Exclusive to Industry Professionals</p>
                </div>
                <div className="col-12 d-flex align-items-center mb-5">
                    <SVG height={20} width={20} src={toAbsoluteUrl(`/media/General/FasterAndSecure.svg`)} />
                    <p className="m-0 ml-3">Faster & More Secure Businesss</p>
                </div>
              </div>
              <div className="col-12 d-flex mb-5 mt-5 justify-content-end">
             
              <Button
                variant="primary"
                style={{
                  background: "linear-gradient(to right, #3B82F6, #2563EB)",
                  border: "none",
                }}
                onClick={() => history.push("/profile")}
              >
                Complete Profile
              </Button>
              </div>
              
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}